import { checkResolution } from 'Functions/helpers';
import { Autoplay } from 'swiper';

export const productsSliderOptions = (instance, options) => {
    // Check if custom slidesPerView is set via data attribute
    const customSlidesPerView = instance.getAttribute('data-slides-per-view');
    const slidesCount = customSlidesPerView ? parseInt(customSlidesPerView) : null;

    const hasMinicartLayout = instance.classList.contains('has-minicart-layout')
    const hasCartLayout = instance.classList.contains('has-cart-layout')

    let responsiveItemCounts = {
        1024: slidesCount !== null ? (slidesCount < 4 ? slidesCount : 4) : 4,
    }

    if (hasCartLayout) {
        // nothing
    }
    else if (hasMinicartLayout) {
        responsiveItemCounts = {...responsiveItemCounts, ...{
            1800: slidesCount !== null ? (slidesCount < 5 ? slidesCount : 5) : 5,
        }}
    } else {
        responsiveItemCounts = {...responsiveItemCounts, ...{
            1280: slidesCount !== null ? (slidesCount < 5 ? slidesCount : 5) : 5,
            1366: slidesCount !== null ? (slidesCount < 6 ? slidesCount : 6) : 6,
        }}
    }

    let breakpoints = {}

    for (const resolution in responsiveItemCounts) {
        const count = responsiveItemCounts[resolution]

        breakpoints[resolution] = {
            slidesPerView: count,
            slidesPerGroup: count,
            spaceBetween: hasMinicartLayout ? 20 : 12,
            cssMode: false,
            pagination: {
                dynamicBullets: false,
            }
        }
    }

    return {
        loop: false,
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        spaceBetween: 0,
        cssMode: true,
        breakpoints: breakpoints
    }
}

export const productB2bOnSaleSliderOptions = (instance, options) => {
    const sliderOptions = {
        modules: [...options.modules, ...[Autoplay]],
        loop: false,
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        spaceBetween: 0,
        cssMode: true,
        pagination: {...options.pagination, ...{
            dynamicBullets: false
        }},
        navigation: {
            prevEl: document.querySelector('[r-slider-prev].is-products-on-sale'),
            nextEl: document.querySelector('[r-slider-next].is-products-on-sale'),
            disabledClass: 'is-disabled',
            hiddenClass: 'is-hidden'
        },
        breakpoints: {
            1280: {
                cssMode: false,
                spaceBetween: 12,
                slidesPerView: 1,
            }
        },
    }

    //? If autoplay is inside breakpoints, it won't work
    //? and behaviour is buggy with using css slider
    if (!checkResolution('cxs;xs;sm')) {
        sliderOptions.autoplay = {
            delay: 3500,
            disableOnInteraction: true,
            pauseOnMouseEnter: true,
        }
    }

    return sliderOptions
}

export const productB2cOnSaleSliderOptions = (instance, options) => {
    const sliderOptions = {
        loop: false,
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        spaceBetween: 30,
        pagination: {...options.pagination, ...{
                dynamicBullets: false
            }},
        breakpoints: {
            1280: {
                spaceBetween: 25,
                slidesPerView: 2,
            }
        }
    }

    return sliderOptions
}

export const promotionProductsSliderOptions = (instance, options) => {
    const hasMinicartLayout = instance.classList.contains('has-minicart-layout')

    let responsiveItemCounts = {
        1024: 3,
    }

    if (hasMinicartLayout) {
        responsiveItemCounts = {...responsiveItemCounts, ...{
            1800: 3,
        }}
    } else {
        responsiveItemCounts = {...responsiveItemCounts, ...{
            1280: 3,
            1366: 3,
        }}
    }

    let breakpoints = {}

    for (const resolution in responsiveItemCounts) {
        const count = responsiveItemCounts[resolution]

        breakpoints[resolution] = {
            slidesPerView: count,
            slidesPerGroup: count,
            spaceBetween: 20,
            cssMode: false,
            pagination: {
                dynamicBullets: false,
            }
        }
    }

    return {
        loop: false,
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        spaceBetween: 0,
        cssMode: true,
        breakpoints: breakpoints
    }
}

export const modalAlternativesSliderOptions = (instance, options) => {
    return {
        loop: false,
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        spaceBetween: 0,
        cssMode: true,
        breakpoints: {
            1024: {
                slidesPerView: 3,
                slidesPerGroup: 3,
                spaceBetween: 12,
                cssMode: false,
                pagination: {
                    dynamicBullets: false,
                }
            }
        }
    }
}

export const pairedProductsSliderOptions = (instance, options) => {
    return {
        loop: false,
        slidesPerView: 2.1,
        slidesPerGroup: 1,
        spaceBetween: 12,
        minSlides: 3,
    }
}